<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.l-wa.fr" target="_blank">Laxmi Web Agency</a>
          </li>
          <li>
            <a href="https://www.goyoga.fr" target="_blank">A propos</a>
          </li>
          <li>
            <a href="https://www.goyoga.fr/fr/blog" target="_blank">Blog</a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.goyoga.fr" target="_blank">GOYOGA</a>, made with
        <i class="fa fa-heart heart"></i> for a new world of sharing and
        happiness
      </div>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
<style></style>
